import React, { Component } from 'react'
import { withRouter } from "react-router";

class TitleBar extends Component{
	constructor(props){
    super(props)
    this.state = {
			showInfoBox: false
    }
	}
	
	componentDidMount() {
    window.scrollTo(0, 0)
	}

	_showInfoBox = () => {
		this.setState({ showInfoBox: !this.state.showInfoBox })
	}

	render() {
		const { showInfoBox } = this.state

		return(
			<nav className="title-bar">
				<div>
					<span onClick={() => this.props.history.goBack()} id="titlebar_back_button"><ion-icon name="arrow-round-back"></ion-icon></span>
				</div>
				<div>
					<h3>{this.props.title}</h3>
				</div>
				<div>
					<ion-icon name={showInfoBox ? "close-circle" : "information-circle"} onClick={this._showInfoBox} className="track-it icon-btn" id={"titlebar_info_"+ this.props.title}></ion-icon>
					<div className={showInfoBox ? "info-box show" : "info-box"}>
						{this.props.content}
					</div>
				</div>
			</nav>
		)
	}
}

export default withRouter(TitleBar)
